var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChangeBranch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19804"
}, /*#__PURE__*/React.createElement("g", {
  fill: "none",
  "data-name": "Group 19792",
  transform: "translate(-40 -208.031)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  "data-name": "Ellipse 1636",
  transform: "translate(40 208.031)"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  "data-name": "Group 19762"
}, /*#__PURE__*/React.createElement("path", {
  d: "M60 217.262a10.76 10.76 0 0 1 8.81 4.574",
  "data-name": "Path 27405"
}), /*#__PURE__*/React.createElement("path", {
  d: "M70.771 228.032A10.77 10.77 0 1 1 60 217.262",
  "data-name": "Path 27406"
}), /*#__PURE__*/React.createElement("path", {
  d: "M68.813 217.262v4.573H64.24",
  "data-name": "Path 27407"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.595 235.58v-9a.967.967 0 0 1 .967-.967h6.89a.967.967 0 0 1 .967.967v8.994",
  "data-name": "Path 27408"
}), /*#__PURE__*/React.createElement("path", {
  d: "M57.493 236.388v-3.02h1.959v3.017",
  "data-name": "Path 27409"
}))))));
export { SvgChangeBranch as ReactComponent };
export default __webpack_public_path__ + "static/media/change_branch.a248995e1a50037e53e4a31c752b5f52.svg";